import React from "react";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import AuthLayout from "../../shared/containers/AuthLayout";
import {deleteRelation} from "./actions/relativesAction";
import {getSeniors} from "./actions/seniorsAction";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from "../../shared/modules/notification/constants";
import {ROUTER_MEMBERS} from "../../shared/constants/routers";
import {ANALYTICS_SPECS} from "../../shared/constants";
import {sendAnalyticsEvent} from "../../shared/actions/analytics";

const Parser = require('html-react-parser');


class DeleteRelation extends React.Component {

  static propTypes = {
    user: PropTypes.object,
    seniors: PropTypes.array,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    seniors: [],
    isLoading: false
  };

  state = { isLoading: false };
  onSubmit = (evt) => {
    evt.preventDefault();
    sendAnalyticsEvent(ANALYTICS_SPECS.MEMBERS.NAME, ANALYTICS_SPECS.MEMBERS.EVENTS.DELETE_CONTACT);
    const {senior} = this.props.location.state;

    deleteRelation(senior, this.props.user)
      .then((seniorToRemove) => {
        this.props.seniors.splice(this.props.seniors.indexOf(seniorToRemove), 1);
      })
      .then(() => {
        this.props.history.push(ROUTER_MEMBERS);
      })
      .then(() => {
        this.props.dispatch(
          notificationAction.addNotification(
            __("Your connection to %senior% has been deleted.")
              .replace('%senior%', `${senior.firstname} ${senior.lastname}`),
            NOTIFICATION_SUCCESS
          )
        );
      })
      .catch(() => {
        this.props.dispatch(
          notificationAction.addNotification(
            __("Something went wrong, try it again later."),
            NOTIFICATION_ERROR
          )
        );
      });
  };

  componentDidMount() {
    if (typeof this.props.location.state !== "undefined" &&
      "senior" in this.props.location.state
    ) {
      this.props.dispatch(getSeniors());
    } else {
      this.props.history.push(ROUTER_MEMBERS);
    }

  }

  render() {
    const {isLoading} = this.state;
    const {firstname, lastname} = this.props.location.state.senior;

    return (
      <AuthLayout title={__("Delete connection to senior")}
                  onBackLink={this.props.history.goBack}>
        <div id="invite">
          <div className="hintBox">
            {Parser(__("Are you sure you want to permanently delete the connection to the senior %senior%?")
              .replace('%senior%', `<span className="seniorsName"> ${firstname} ${lastname} </span>`))}
          </div>
          <form onSubmit={this.onSubmit}>
            <button className="buttonPrimary" disabled={isLoading}>
              {__("Delete now")}
            </button>
          </form>
        </div>
      </AuthLayout>
    );
  }
}

export default withRouter(DeleteRelation);
